import Ripple from "./Ripple";
import Ring from "./Ring";
import Dots from "./Dots";

export const LoaderTypes = {
  Ripple,
  Ring,
  Dots
};
